module.exports = __webpack_public_path__ + "img/20200115160048360截图20200115112001298.0a3f34ee.jpg";